import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const WrapperBox = styled(Box)`
  overflow: hidden;
`;

export const StyledBox = styled(Box)`
  text-align: center;
`;

export const Heading = styled(Box)`
  max-width: 470px;
  margin: auto;
  ${themeMediaQuery('xl')} {
    max-width: 590px;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    margin-bottom: ${themeSpace(6)};
  }
`;

export const AssetsWrapperBox = styled(Box)`
  display: flex;
  justify-content: center;
`;

export const AssetsBox = styled(Box)<{ width: number; reswidth: number }>`
  z-index: 1;
  position: relative;
  animation: scroll 30s linear infinite;
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-${({ width }) => width}px);
    }
  }
  ${themeMediaQuery('below_sm')} {
    @keyframes scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-${({ reswidth }) => reswidth}px);
      }
    }
  }
`;

export const AssetsBoxSecond = styled(AssetsBox)`
  left: ${({ width }) => width}px;
  ${themeMediaQuery('below_sm')} {
    left: ${({ reswidth }) => reswidth}px;
  }
`;

export const AssetsBoxArts = styled(Box)`
  z-index: 0;
  position: relative;
`;

export const ForegroundAssetsBox = styled(Box)`
  z-index: 2;
  position: relative;
`;

export const AssetsCloudImage = styled(CloudImage)<{
  width: number;
  reswidth: number;
  offset: number;
  top?: number;
  zindex?: number;
  restop?: number;
  resoffset?: number;
  isleft?: boolean;
  iscircle?: boolean;
  isradius?: boolean;
}>`
  position: absolute;
  height: ${({ width, iscircle }) => (iscircle ? width + 'px' : 'auto')};
  left: ${({ offset, isleft }) => (isleft ? offset + 'px' : '')};
  right: ${({ offset, isleft }) => (isleft ? '' : offset + 'px')};
  top: ${({ top }) => (top ? top + 'px' : '')};
  border-radius: ${({ iscircle, isradius }) => (iscircle ? '50%' : isradius ? '4px' : '')};
  z-index: ${({ zindex }) => (zindex ? zindex : 2)};
  width: ${({ width }) => width}px;
  ${themeMediaQuery('below_sm')} {
    top: ${({ restop }) => (restop ? restop + 'px' : '')};
    width: ${({ reswidth }) => reswidth}px;
    height: ${({ reswidth, iscircle }) => (iscircle ? reswidth + 'px' : 'auto')};
    left: ${({ resoffset, isleft }) => (isleft ? resoffset + 'px' : '')};
    right: ${({ resoffset, isleft }) => (isleft ? '' : resoffset + 'px')};
  }
`;

export const BackgroundYellowWrapper = styled(Box)`
  z-index: 0;
  position: relative;
`;

export const LeftBackgroundYellow = styled(CloudImage)`
  position: absolute;
  height: auto;
  left: 0;
  top: 500px;
  z-index: 1;
  width: 220px;
  ${themeMediaQuery('below_sm')} {
    top: 275px;
    width: 120px;
  }
`;
